<template>
  <section class="bonita__form">
    <h1>{{ title }}</h1>
    <h2>{{ subtitle }}</h2>

    <section v-html="$t('close', { mail })"/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Close',

  computed: {
    ...mapGetters([
      'population',
    ]),
    title () {
      const population = this.population ? this.population : 'other'
      return this.$t(`forms.sep.${population}.mainTitle`)
    },
    subtitle () {
      return this.population ? this.$t(`forms.sep.${this.population}.mainSbuTitle`) : ''
    },
    mail () {
      let mail = ''

      switch (this.$store.getters['population']) {
        case 'iut':
          mail = '<a href="mailto:ri@iutrs.unistra.fr">ri@iutrs.unistra.fr</a>'
          break
        case 'law':
          mail = '<a href="mailto:droit-erasmus@unistra.fr">Service des relations internationales</a>'
          break
        case 'em':
          mail = '<a href="mailto:sri-incoming@em-strasbourg.eu">Service des relations internationales</a>'
          break
        case 'other':
          mail = '<a href="mailto:scensi@unistra.fr">Mme Séverine CENSI</a>'
          break
        case 'sciencePo':
          mail = '<a href="mailto:iep.incomingstudents@unistra.fr">iep.incomingstudents@unistra.fr</a>'
          break
      }

      return mail
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../assets/style";

  .bonita__form {
    section {
      margin-top: 50px;
    }
  }
</style>
